// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__5bfsI","actionsCol":"EnrolledClinics_actionsCol__OLs0X"};